var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.showDetail)?_c('order-history',{attrs:{"msg":"Order History"}}):_vm._e(),(_vm.showDetail)?_c('order-detail',{on:{"view:detail":function($event){return _vm.showOrderDetail()}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }